import React, { useEffect, useState, Component } from 'react';
import { observer } from 'mobx-react';

import { ShopStore, InspectionsStore, CurrentUserStore } from 'stores';
import { Col, Row, Button, Table, Dropdown, Space, Popconfirm } from 'antd';
import { DownOutlined, UserOutlined, DeleteOutlined } from '@ant-design/icons';
import { useHistory, useParams } from 'react-router-dom';
import { Logger } from 'stores/Classes';

import { Link } from 'react-router-dom';

function Inspections() {
  const [templates, setTemplates] = useState([]);
  const [forms, setForms] = useState([]);

  const { id } = useParams();

  const columns = [
    {
      title: 'Name',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Asset',
      dataIndex: 'car_name',
      key: 'car_name',
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (value) => new Date(value).toLocaleString(),
    },
    {
      title: 'Created By',
      key: 'created_by',
      render: (_, record) => `${record.first_name} ${record.last_name}`,
    },
    {
      title: 'Work Order',
      dataIndex: 'work_order_id',
      key: 'work_order_id',
      render: (_, record) => (
        <Link
          to={`/work-order/${record.work_order_id}/edit`}
          onClick={(e) => e.stopPropagation()}
        >
          {record.work_order_number}
        </Link>
      ),
    },
    {
      key: 'action',
      render: (_, record) =>
        CurrentUserStore.allowManager && (
          <div onClick={(e) => e.stopPropagation()}>
            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => onDelete(record)}
            >
              <DeleteOutlined />
            </Popconfirm>
          </div>
        ),
    },
  ];

  let history = useHistory();

  useEffect(() => {
    const initialize = async () => {
      await loadData(ShopStore.currentShop.id, id);
    };

    initialize();
  }, []);

  useEffect(() => {
    loadData(ShopStore.currentShop.id, id);
  }, [ShopStore.currentShop.id]);

  const loadData = async (shopId, id) => {
    try {
      const templates = await InspectionsStore.getTemplates(shopId);

      setTemplates(templates);

      const forms = await InspectionsStore.getInspectionForms(shopId, id);

      setForms(forms);
    } catch (e) {
      Logger.log(e);
    }
  };

  const onDelete = async (record) => {
    try {
      const formId = record.form_id;
      const shopId = ShopStore.currentShop.id;

      await InspectionsStore.deleteForm(shopId, formId);

      const newForms = forms.filter((form) => form.form_id !== formId);

      setForms(newForms);
    } catch (e) {
      Logger.log(e);
    }
  };

  const items = templates.map((template, index) => {
    return {
      key: index,
      label: (
        <Link to={`/inspection-forms/${template.form_id}/create`}>
          {template.title}
        </Link>
      ),
    };
  });

  return (
    <div>
      <Row style={{ marginBottom: '10px' }}>
        <Col span={12}></Col>
        <Col span={12} style={{ textAlign: 'right' }}>
          <Dropdown menu={{ items }}>
            <Button type="primary">
              <Space>Add New</Space>
            </Button>
          </Dropdown>
        </Col>
      </Row>
      <div
        style={{
          width: '100%',
          maxWidth: '90vw',
          boxSizing: 'border-box',
          overflowX: 'auto',
        }}
      >
        <Table
          columns={columns}
          dataSource={forms}
          rowKey="id"
          onRow={(record) => ({
            onClick: () =>
              history.push(`/inspection-forms/forms/${record.form_id}/edit`),
            style: { cursor: 'pointer' },
          })}
          pagination={{ position: ['bottomCenter'] }}
        />
      </div>
    </div>
  );
}

export default observer(Inspections);
